"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Providers = exports.Provider1 = void 0;
exports.Provider1 = {
    id: "1012fec4-057b-4429-929e-f57a9fefa484",
    status: "ACTIVE",
    createdBy: "b53ef72f-ef46-4d9b-b28b-2de2692ba8ba",
    modifiedBy: "b53ef72f-ef46-4d9b-b28b-2de2692ba8ba",
    modifiedAt: "2023-03-07T11:00:10.000Z",
    source: null,
    prov_cred_id: null,
    prov_cred: "PhD",
    ext_name: null,
    prov_id: "1004061",
    sex: "M",
    res_name: "Person",
    prov_name: "FOEHL, JOHN C",
    prov_abbr: "FOEHL, JOHN ",
    prov_type: null,
    createdAt: "2023-03-07T11:00:10.000Z",
    deletedAt: null,
    identifier_id: "cdef33ae-65a9-485a-b17f-dea4241b9a1c",
    id_type_code: "",
    start_date: null,
    id_value: "1043265127",
    end_date: null,
    id_type: "NPI"
};
exports.Providers = [
    {
        active: "true",
        provider_name: "Provider with no role, 1",
        provider_id: "H504219",
        prov_cred: "MD, PhD, CNM",
        lineage: "SER",
        specialties: []
    },
    {
        active: "true",
        provider_name: "Provider with role, no specialty, 2",
        provider_id: "H504219",
        prov_cred: "MD, PhD, CNM",
        lineage: "SER",
        specialties: [
            {
                name: "Physician",
                report_grouper_twelve: "...",
                specialty: null,
                billable: false,
                location: null
            }
        ]
    },
    {
        active: "true",
        provider_name: "Provider with one specialty, not billable, 3",
        provider_id: "H504219",
        prov_cred: "MD, PhD, CNM",
        lineage: "SER",
        specialties: [
            {
                name: "Physician",
                report_grouper_twelve: "...",
                specialty: "GI",
                billable: false,
                location: null
            }
        ]
    },
    {
        active: "true",
        provider_name: "Provider with one specialty, billable, 4",
        provider_id: "H504219",
        prov_cred: "MD, PhD, CNM",
        lineage: "SER",
        specialties: [
            {
                name: "Physician",
                report_grouper_twelve: "...",
                specialty: "GI",
                billable: true,
                location: null
            }
        ]
    },
    {
        active: "true",
        provider_name: "Provider with one specialty, flag, not billable, 5",
        provider_id: "H504219",
        prov_cred: "MD, PhD, CNM",
        lineage: "SER",
        specialties: [
            {
                name: "Physician",
                report_grouper_twelve: "...",
                specialty: "GI",
                billable: false,
                specialty_flag: "Dual Provider",
                location: null
            }
        ]
    },
    {
        active: "true",
        provider_name: "Provider with one specialty, flag, billable, 6",
        provider_id: "H504219",
        prov_cred: "MD, PhD, CNM",
        lineage: "SER",
        specialties: [
            {
                name: "Physician",
                report_grouper_twelve: "...",
                specialty: "GI",
                billable: true,
                specialty_flag: "Dual Provider",
                location: null
            }
        ]
    },
    {
        active: "true",
        provider_name: "PASTRICH, HOWARD J",
        provider_id: "H504219",
        prov_cred: "MD, PhD, CNM",
        lineage: "SER",
        specialties: [
            {
                name: "Physician",
                report_grouper_twelve: "...",
                specialty: "GI",
                billable: true,
                location: null
            },
            {
                name: "Resident",
                specialty: "Cardiology",
                billable: false,
                report_grouper_twelve: "...",
                location: null
            }
        ]
    },
    {
        active: "true",
        provider_name: "2PASTRICH, HOWARD J",
        provider_id: "H5042190",
        prov_cred: "MD, PhD, CNM",
        lineage: "SER",
        specialties: [
            {
                name: "Physician",
                report_grouper_twelve: "...",
                specialty: "GI",
                billable: false,
                location: null
            },
            {
                name: "Resident",
                specialty: "Cardiology",
                billable: false,
                report_grouper_twelve: "...",
                specialty_flag: "Dual Provider",
                location: null
            }
        ]
    }
];
//# sourceMappingURL=provider-entity.js.map